// Import Shared Utils
import { formatCountryCode } from 'shared-components/src/utils/formatCountry';
import { formatCurrencyV } from 'shared-components/src/utils/formatCurrency';

export default [
  {
    Header: 'External Tag',
    accessor: 'external_tag',
    Cell: ({ value }) => (value.length > 0 ? value : '--'),
  },
  {
    Header: 'First Name',
    accessor: 'first_name',
  },
  {
    Header: 'Last Name',
    accessor: 'last_name',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Date of Birth',
    accessor: 'date_of_birth',
  },
  {
    Header: 'Address Line 1',
    accessor: 'address1',
  },
  {
    Header: 'Postal Code',
    minWidth: 60,
    accessor: 'postal_code',
  },
  {
    Header: 'Country',
    accessor: 'country',
    minWidth: 45,
    Cell: ({ value }) => formatCountryCode(value),
  },
  {
    Header: 'Value Load',
    accessor: 'load_amount',
    Cell: ({ value }) => formatCurrencyV(value / 100),
  },
  {
    Header: 'SIN/SSN',
    accessor: 'sin',
  },
  {
    Header: 'Office Id',
    accessor: 'office_id',
    Cell: ({ value }) => value || '--'
  },
  {
    Header: 'Employer Name',
    accessor: 'employer_name',
    Cell: ({ value }) => value || '--'
  },
  {
    Header: 'Occupation',
    accessor: 'occupation',
    Cell: ({ value }) => value || '--'
  },
  {
    Header: 'Non Resident Alien',
    accessor: 'non_resident_alien',
    Cell: ({ value }) => value === true ? 'Y' : value === false ? 'N' : '--'
  },
  {
    Header: 'Politically Exposed Person',
    accessor: 'politically_exposed_person',
    Cell: ({ value }) => value === true ? 'Y' : value === false ? 'N' : '--'
  },
  {
    Header: 'Primary Source Of Funds',
    accessor: 'primary_source_of_funds',
    Cell: ({ value }) => value || '--'
  },  {
    Header: 'Primary Use Of Account',
    accessor: 'primary_use_of_account',
    Cell: ({ value }) => value || '--'
  },
  {
    Header: 'Country Of Citizenship',
    accessor: 'country_of_citizenship',
    Cell: ({ value }) => value || '--'
  },
];
